<div class="component d-flex flex-column align-items-center">
  <div class="font-weight-bold text-start font-size-normal text-primary" [appCustomTooltip]="tolTemplate" placement="bottom">
    <div [id]="chartId" class="tachometer-chart-container"></div>
  </div>
  <div class="font-size-verysmall">
    {{
      translateService.instant('COMPONENT_LIBRARY.TACHOMETER.TITLE') !== 'COMPONENT_LIBRARY.TACHOMETER.TITLE' ?
        translateService.instant('COMPONENT_LIBRARY.TACHOMETER.TITLE') :
        'YTD Prod. vs Bdg.'}} {{ budgetData?.budget_actual | number: '1.1-1' | customNumberFormat
    }}%
  </div>
</div>

<ng-template #tolTemplate>
  <div class="text-primary font-weight-bold tooltip-content">
    <div>{{translateService.instant('COMPONENT_LIBRARY.TACHOMETER.YTD_ACTUAL_BY_BUDGET')}}: <b>{{ YTDPercentage | percent: '1.1-1' }}</b></div>
    <div>{{translateService.instant('COMPONENT_LIBRARY.TACHOMETER.YTD_ACTUAL_BY_ANNUAL_BUDGET', { year })}}: <b>{{ budget | number: '1.1-1' | customNumberFormat }}%</b></div>
    <div>{{translateService.instant('COMPONENT_LIBRARY.TACHOMETER.YTD_BUDGET_BY_ANNUAL_BUDGET', { year })}}: <b>{{ revenues | number: '1.1-1' | customNumberFormat }}%</b></div>
    <div>{{translateService.instant('COMPONENT_LIBRARY.TACHOMETER.YTD_ACTUAL_PRODUCTION')}}: <b>{{ ytdactual | number: '1.1-1' | customNumberFormat }} GWh</b></div>
    <div>{{translateService.instant('COMPONENT_LIBRARY.TACHOMETER.YTD_BUDGET_PRODUCTION')}}: <b>{{ ytdbudget | number: '1.1-1' | customNumberFormat }} GWh</b></div>
    <div>{{translateService.instant('COMPONENT_LIBRARY.TACHOMETER.ANNUAL_BUDGET_PRODUCTION', { year })}}: <b>{{ annualbudget | number: '1.1-1' | customNumberFormat }} GWh</b></div>
  </div>
</ng-template>